export default __webpack_public_path__ + "static/media/pop_logo_ko-KR.e93c1fd7.png";